function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 10.618v9.503h-2V10.61L8.979 12.63l-1.415-1.414L10.582 8.2l-.002-.002 1.414-1.415.002.002.002-.002 1.414 1.415-.002.002 3.018 3.017-1.415 1.414L13 10.618zm8-4.74H3v-2h18v2z",
  fill: "#16191C",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;